var hasAcceptedTargeting = function () {
    return ICF.Utils.Consent.CookieContainsPattern(ICF.Variables.ConsentGroupPatterns.AcceptedTargeting)
};

module.exports = hasAcceptedTargeting;